import '../stylesheets/cemantix.scss';

window.components = {
  ...window.components,
  'Cemantix': require('../components/Cemantix')
}

window.mountComponents(window.components);
